import { Typography } from '@compass/Typography/Typography'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.Tor
const label = visitFilterLabelMap[key]

export const torColumn = () =>
  columnHelper.display({
    id: 'tor',
    header: 'Tor',
    cell: ({ row }) => {
      const result = row.original.ip_blocklist?.tor_node

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
